import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { CouponDetail } from './CouponDetail';
import { CouponList } from './CouponList';

export const Coupon = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={CouponList} />;
    <Route path={`${props.match.path}/:id`} component={CouponDetail} />;
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/coupon/Coupon.tsx